// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"BalanceOverview-module--tableContainer--3pLmM","chartContainer":"BalanceOverview-module--chartContainer--13A_k"};